export enum ContextType {
    Main = "main",
    TaskPane = "taskpane",
}